import AgencyManageAccount from './components/AgencyManageAccount.js';
import connect from './connect';
import './assets/AgencyManageAccount.css';

export default connect(AgencyManageAccount);



// WEBPACK FOOTER //
// ./src/routes/AgencyManageAccount/index.js